import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { axiosInstanceAuth } from "../../Utils/AxiosInstance";

export const EvolutionSocketContext = createContext();

export const EvolutionSocketProvider = ({ children }) => {
  // const socketRef = useRef(null);

  // useEffect(() => {
  //   const socket = io("http://localhost:8080", {
  //     path: "/Test", // instance name
  //     transports: ["websocket"],
  //     reconnection: true,
  //   });

  //   socketRef.current = socket;

  //   socket.on("connect", () => console.log("✅ Connected to Evolution API WS"));
  //   socket.on("disconnect", () => console.log("❌ Disconnected from WS"));

  //   socket.on("messages.upsert", data => console.log("💬 messages.upsert:", data));
  //   socket.on("contacts.upsert", data => console.log("📩 contacts.upsert:", data));
  //   socket.on("messages.update", data => console.log("✏️ messages.update:", data));

  //   return () => socket.disconnect();
  // }, []);

  const [allContacts, setAllContacts] = useState([]); // { groupId: [msg, msg, ...] }
  // console.log("allContacts", allContacts);
  const fetchContacts = async instance => {
    try {
      const response = await axiosInstanceAuth.post(
        `/Whatsapp/FindContactsOfChat?instanceName=${encodeURIComponent(instance)}`
      );
      const data = response.data;
      if (data) {
        setAllContacts(data);
      }
    } catch (error) {
      // console.log(error.message);
    }
  };
  return (
    <EvolutionSocketContext.Provider value={{ allContacts, setAllContacts, fetchContacts }}>
      {children}
    </EvolutionSocketContext.Provider>
  );
};

// 🔹 Custom Hook for easy access
export const useEvolutionSocket = () => useContext(EvolutionSocketContext);

EvolutionSocketProvider.propTypes = {
  children: PropTypes.any,
};
